import styles from "./index.module.scss";

type Props = {
  src: string;
  alt: string;
  caption?: string;
};

const CultureImagePopupImage = ({ src, alt, caption }: Props) => {
  return (
    <figure className={styles.cultureImagePopupImage}>
      <picture className={styles.imageContainer}>
        <img src={src} alt={alt} />
      </picture>
      <p className={[styles.caption, "description"].join(" ")}>{caption}</p>
    </figure>
  );
};

export default CultureImagePopupImage;
